import styled from "styled-components";

export const ButtonStyled = styled.button`
  border: none;
  background: none;
`